import moment from 'moment';


export default function DateFormating(val){
  const date = moment(val).format('DD.MM.yyyy HH:mm');
  if(date) {
    return date
  }
}
